// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` /* TournamentList.css */
 .tournament-list {
    border-radius: 10px;
    width: 100%;
    margin: 20px auto;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .tournament-list h2 {
    color: #a3cc1b;
    font-size: 24px;
    margin-bottom: 20px;
    text-align: center;
  }
  
  .tournament-list ul {
    list-style-type: none;
    padding: 0;
  }
  
  .tournament-item {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-bottom: 15px;
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }
  
  .tournament-details h3 {
    color: #333;
    font-size: 24px;
    margin: 0 0 5px 0;
  }
  
  .tournament-details p {
    color: #666;
    text-align: center;
    margin: 5px 0;
  }

  .tournament-actions{
    display: flex;
    gap: 8px;
    width: 100%;
  }
  
  .tournament-actions button {
    background-color: #a3cc1b;
    color: white;
    border: none;
    padding: 10px;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    width: 50%
  }
  
  .tournament-actions button:hover {
    background-color: #8bb010;
  }
  
  .delete-button {
    background-color: #e74c3c;
  }
  
  .delete-button:hover {
    background-color: #c0392b;
  }`, "",{"version":3,"sources":["webpack://./src/components/AdminDashboard/TournamentList.css"],"names":[],"mappings":"CAAC,uBAAuB;CACvB;IACG,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,0CAA0C;EAC5C;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf;EACF;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[" /* TournamentList.css */\r\n .tournament-list {\r\n    border-radius: 10px;\r\n    width: 100%;\r\n    margin: 20px auto;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .tournament-list h2 {\r\n    color: #a3cc1b;\r\n    font-size: 24px;\r\n    margin-bottom: 20px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .tournament-list ul {\r\n    list-style-type: none;\r\n    padding: 0;\r\n  }\r\n  \r\n  .tournament-item {\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: #ffffff;\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n    margin-bottom: 15px;\r\n    padding: 15px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 16px;\r\n  }\r\n  \r\n  .tournament-details h3 {\r\n    color: #333;\r\n    font-size: 24px;\r\n    margin: 0 0 5px 0;\r\n  }\r\n  \r\n  .tournament-details p {\r\n    color: #666;\r\n    text-align: center;\r\n    margin: 5px 0;\r\n  }\r\n\r\n  .tournament-actions{\r\n    display: flex;\r\n    gap: 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .tournament-actions button {\r\n    background-color: #a3cc1b;\r\n    color: white;\r\n    border: none;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    width: 50%\r\n  }\r\n  \r\n  .tournament-actions button:hover {\r\n    background-color: #8bb010;\r\n  }\r\n  \r\n  .delete-button {\r\n    background-color: #e74c3c;\r\n  }\r\n  \r\n  .delete-button:hover {\r\n    background-color: #c0392b;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
